import styles from "./Section2.module.scss";

export const Section2 = function () {
  return (
    <section id="statistics" className={`${styles.section2Wrapper} cc--component-container`}>
      <div className={styles.section2Container}>
        <div className={styles.section2Content}>
          <p style={{ fontSize: 20 }}>
            <strong>Level up for less. Take 15% off select course fees until July 30, 2025.</strong>
          </p>
          <p>There&apos;s never been a better time to take a strategic step toward your goals.</p>
          <p>
            Use code <strong>LEVELUP25</strong> at checkout.*
          </p>
          <p className={styles.section2Disclaimer}>
            <em>
              *Offer applies to any start date for participating courses where registration is currently open as long as
              you register and pay by July 30, 2025, at 11:59 p.m. Eastern Time (U.S.). To redeem the offer for
              executive education courses, register on getsmarter.com, using code LEVELUP25 at checkout. The discount
              cannot be combined with any other offers for executive education courses.
            </em>
          </p>
        </div>
      </div>
    </section>
  );
};
